import React, { Fragment, FunctionComponent } from "react";
import styles from "./Button.module.scss";
import ButtonProps from "./ButtonProps.interface";

import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import getRelativeUrl from "helpers/getRelativeUrl";
import IconViewer from "components/IconViewer/IconViewer";

const Button: FunctionComponent<ButtonProps> = (props) => {
    const buttonTypeClass = props.settings && props.settings.buttonType ? styles[`button_${props.settings.buttonType}`] : undefined;

    return (
        <Fragment>
            {/* Modal */}
            {typeof (props.onClick) !== "undefined" && props.modal && (!props.anchor || props.anchor.length === 0) && !props.to ? (
                <button style={props.style} className={combineClasses([buttonTypeClass, props.className])} onClick={props.onClick}>
                    {props.children}
                </button>
            ) : null}

            {/* Function */}
            {typeof (props.onClick) !== "undefined" && (!props.anchor || props.anchor.length === 0) && !props.to && !props.modal ? (
                <button style={props.style} className={combineClasses([buttonTypeClass, props.className])} onClick={props.onClick}>
                    {props.children}
                </button>
            ) : null}

            {/* Link */}
            {(!props.anchor || props.anchor.length === 0) && props.to ? (
                <Anchor style={props.style} className={combineClasses([buttonTypeClass, props.className])} to={getRelativeUrl(`${props.to}${props.parameters ? props.parameters : ""}`)}>
                    {props.children}
                </Anchor>
            ) : null}

            {/* Anchor */}
            {!props.to && props.anchor && props.anchor.length > 0 ? (
                <Anchor style={props.style} className={combineClasses([buttonTypeClass, props.className])} to={getRelativeUrl(props.anchor[0].url)}>
                    {props.children}
                    <IconViewer className={styles.anchor_icon} name="arrow-bottom-right" />
                </Anchor>
            ) : null}
        </Fragment>
    );
};

export default Button;